@if (isLoaded) {
  <aecom-form columns="12" class="contentcontainer">
    @if (items.length > 0) {
      <aecom-form-group columnSpan="12" columns="1" title="Internal Notes" style="margin-bottom: 40px">
        <aecom-form-item columnSpan="1">
          @for (item of items; track item) {
            <div class="responseBox" [ngClass]="{'rejectedBox': item.IsBack}">
              <div class="responseHeader">
                <span>{{ item.Name }}</span>
                <span class="responseHeaderSeparate_b">|</span>
                <span>{{ item.Role }}</span>
                <div class="responseHeaderDate">{{ item.FormatedDateUpdated }}</div>
                <div class="responseHeaderCollapse" (click)="item.Collapse = !item.Collapse">
                  <i
                [ngClass]="
                  item.Collapse
                    ? 'icon-action_arrow_down'
                    : 'icon-action_arrow_up'
                "
                    class="icon icon-blue icon-lg"
                  ></i>
                </div>
              </div>
              @if (!item.Collapse) {
                <div class="responseContent">
                  <div class="responseBody">
                    <div class="responseBodySubTitle">{{item.Title}}</div>
                    <div class="responseBodySubContent" [innerHtml]="item.Notes"></div>
                  </div>
                  @if (item.ScheduleImpact || item.CostImpact) {
                    <div class="responseBody">
                      <div class="flexBox">
                        <div class="halfBox">
                          <div class="responseBodySubTitle">Schedule Impact (Internal)</div>
                          <div class="responseBodySubContent">{{item.ScheduleImpact}}</div>
                        </div>
                        <div class="halfBox">
                          <div class="responseBodySubTitle">Cost Impact (Internal)</div>
                          <div class="responseBodySubContent">{{item.CostImpact}}</div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (item.Attachments && item.Attachments.length > 0) {
                    <div class="responseBody">
                      <bbj-file-list
                        [fileList]="item.Attachments"
                        title="Attachments"
                        [allowMovingFiles]="allowMovingFiles()"
                        (movedFile)="attachmentOut($event)"
                        (movedFiles)="attachmentsOut($event)"
                      ></bbj-file-list>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </aecom-form-item>
      </aecom-form-group>
    }
    <aecom-form-group columnSpan="12" columns="2" title="Processing Metadata" style="margin-bottom: 40px; position: relative;">
      <aecom-form-item [label]="'Internal Due Date'" columnSpan="1">
        @if (entity.InternalDueDate) {
          <div
            class="itemText"
            >
            {{ getFixedDateTime(entity.InternalDueDate) }}
          </div>
        } @else {
          <div class="itemText">-</div>
        }
      </aecom-form-item>
      <aecom-form-item [label]="'Target Due Date'" columnSpan="1">
        @if (entity.DueDate) {
          <div
            class="itemText"
            >
            {{ getFixedDateTime(entity.DueDate) }}
          </div>
        } @else {
          <div class="itemText">-</div>
        }
      </aecom-form-item>
      <aecom-form-item [label]="'Schedule Impact (Internal)'" columnSpan="1">
        @if (scheduleImpace) {
          <div class="itemText">
            {{ scheduleImpace }}
          </div>
        } @else {
          <div class="itemText">-</div>
        }
      </aecom-form-item>
      <aecom-form-item [label]="'Cost Impact (Internal)'" columnSpan="1">
        @if (costImpace) {
          <div class="itemText">
            {{ costImpace }}
          </div>
        } @else {
          <div class="itemText">-</div>
        }
      </aecom-form-item>
      @if (canUpdateDueDate) {
        <div style="position: absolute; top: 7px; right: 0; cursor: pointer;">
          <div class="formGroupManu" (click)="updateDueDate()">
            UPDATE DUE DATE
          </div>
        </div>
      }
    </aecom-form-group>
    <aecom-form-group columnSpan="12" columns="2" title="Processing Roles" style="margin-bottom: 40px">
      <aecom-form-item [label]="'Doc Control'" columnSpan="1">
        @if (docControlUser) {
          <div class="itemText">
            {{ docControlUser?.displayName }} ({{ docControlUser?.mail }})
          </div>
        } @else {
          <ng-template [ngTemplateOutlet]="(showDocControl===true && notAvailable) || notProvide"></ng-template>
        }
      </aecom-form-item>
      <aecom-form-item [label]="'Coordinator'" columnSpan="1">
        @if (coordinator) {
          <div class="itemText">
            {{ coordinator.displayName }} ({{ coordinator.mail }})
          </div>
        } @else {
          <ng-template [ngTemplateOutlet]="(showCoordinator===true && notAvailable) || notProvide"></ng-template>
        }
      </aecom-form-item>
      <aecom-form-item [label]="'Project Manager'" columnSpan="1">
        @if (manager) {
          <div class="itemText">
            {{ manager.displayName }} ({{ manager.mail }})
          </div>
        } @else {
          <ng-template [ngTemplateOutlet]="(showManager===true && notAvailable) || notProvide"></ng-template>
        }
      </aecom-form-item>
      <aecom-form-item [label]="'Sr. Project Manager'" columnSpan="1">
        @if (srManager) {
          <div class="itemText">
            {{ srManager.displayName }} ({{ srManager.mail }})
          </div>
        } @else {
          <ng-template [ngTemplateOutlet]="(showSrManager===true && notAvailable) || notProvide"></ng-template>
        }
      </aecom-form-item>
      <aecom-form-item [label]="'DDC Manager'" columnSpan="1">
        @if (ddcManager) {
          <div class="itemText">
            {{ ddcManager.displayName }} ({{ ddcManager.mail }})
          </div>
        } @else {
          <ng-template [ngTemplateOutlet]="(showDDCManager===true && notAvailable) || notProvide"></ng-template>
        }
      </aecom-form-item>
    </aecom-form-group>
    @if (showWorkflow) {
      <aecom-form-group columnSpan="12" columns="1" title="Workflow History" style="margin-bottom: 40px">
        <workflowHistory [data]="workflowHistorys" [showDays]="true"></workflowHistory>
      </aecom-form-group>
    }
  </aecom-form>
}

<ng-template #notAvailable>
  <div class="itemText">N/A</div>
</ng-template>

